import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import { Button, Table } from "react-bootstrap";
import { getAllVendors } from "../Service/VendorService";
import { useToast } from "../Components/toast/ToastProvider";
import PaymentFilter from "../Components/PaymentFilter";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "react-feather";
import { formatDate } from "../config/function";
import { getAllVehicles } from "../Service/VehicleService";
import { getBillsByFilter } from "../Service/BillService";

const PaymentReportPage = () => {
  const toast = useToast();

  const [vendors, setVendors] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [allTrips, setAllTrips] = useState([]);
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [filters, setFilters] = useState({
    vendor_id: "",
    date: "",
    status: "",
  });
  const [showResults, setShowResults] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadVendors();
  }, []);

  const loadVendors = async () => {
    try {
      const [venRes, vehRes] = await Promise.all([
        getAllVendors(),
        getAllVehicles(),
      ]);
      setVendors(venRes.data || []);
      setVehicles(vehRes.data || []);
    } catch (err) {
      toast("Error loading vendors", "error");
    }
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const handleFilter = async () => {
    setLoading(true);
    if (!filters.vendor_id && !filters.date && !filters.status) {
      toast("Please select at least one field", "ERROR");
      return;
    }

    try {
      const res = await getBillsByFilter({
        vendor_id: filters.vendor_id,
        date: filters.date,
        status: filters.status,
      });

      console.log("res", res);
      // setFilteredPayments(res.data || []);
      setTimeout(() => {
        setFilteredPayments(res?.data?.bill || []);
        setAllTrips(res?.data?.trips || []);
        setShowResults(true);
        setLoading(false);
      }, 1500);
    } catch (err) {
      toast("Filter failed", "error");
    }
  };

  const handleReset = () => {
    setFilters({ vendor_id: "", date: "", status: "" });
    setFilteredPayments(payments);
    setShowResults(false);
  };

  const addPDFHeader = (doc, pageWidth) => {
    const logo = new Image();
    logo.src = "/img/asa_logo.png";

    const logoWidth = 18;
    const logoHeight = 18;
    const spacing = 5;

    const headerText = "ASA Transport";
    const subHeaderText = "Mannargudi";

    const headerWidth = doc.getTextWidth(headerText);
    const subHeaderWidth = doc.getTextWidth(subHeaderText);
    const totalWidth =
      logoWidth + spacing + Math.max(headerWidth, subHeaderWidth);
    const startX = (pageWidth - totalWidth) / 2;

    try {
      doc.addImage(logo, "PNG", startX, 8, logoWidth, logoHeight);
    } catch (e) {
      console.warn("Logo load skipped (small size optimization)");
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(headerText, startX + logoWidth + spacing, 14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(subHeaderText, startX + logoWidth + spacing, 20);
  };
  const generatePaymentTablePDF = () => {
    if (filteredPayments.length === 0) {
      toast("No payment to export", "ERROR");
      return;
    }
    const doc = new jsPDF({ orientation: "potrait", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    const capitalize = (str) => {
      if (!str) return "N/A";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };
    addPDFHeader(doc, pageWidth);
    doc.setFontSize(13);
    doc.setFont("helvetica", "bold");
    doc.text("Payment Details", pageWidth / 2, 35, { align: "center" });

    let selectedVendor = null;

    if (filters.vendor_id) {
      selectedVendor = vendors.find(
        (v) => v.id === parseInt(filters.vendor_id),
      );
    } else if (filters.vehicle_id) {
      const selectedVehicle = vehicles.find(
        (v) => v.id === parseInt(filters.vehicle_id),
      );

      if (selectedVehicle) {
        selectedVendor = vendors.find(
          (ven) => ven.id === selectedVehicle.vendor_id,
        );
      }
    }
    const vendorName = capitalize(selectedVendor?.name || "All Vendors");
    const vendorMobile = selectedVendor?.contact_number || "-";
    const vendorAddress = capitalize(selectedVendor?.location || "-");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);

    let y = 45;
    doc.text(`Vendor Name: ${vendorName}`, 14, y);
    if (selectedVendor) {
      y += 6;
      doc.text(`Mobile: ${vendorMobile}`, 14, y);
      y += 6;
      doc.text(`Address: ${vendorAddress}`, 14, y);
    }

    const tableColumn = [
      "S.No",
      "Date",
      "Vendor Name",
      "Trip Count",
      "Total Amount",
      // "NormalAdvance Deduction",
      // "receipt Advance Deduction",
      "Payable Amount",
    ];

    const tableRows = filteredPayments.map((p, index) => {
      const vendorName = vendors.find((v) => v.id === p.vendor_id);
      return [
        index + 1,
        formatDate(p.date),
        capitalize(vendorName?.name || "N/A"),
        p.trip_count || 0,
        p.total_amount?.toFixed(2) || "0.00",
        // p.nor_advance_deduction?.toFixed(2) || "0.00",
        // p.res_advance_deduction?.toFixed(2) || "0.00",
        p.payable_amount?.toFixed(2) || "0.00",
      ];
    });

    autoTable(doc, {
      startY: y + 10,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
    });

    const pdfOutput = doc.output("arraybuffer");
    const fileSizeKB = pdfOutput.byteLength / 1024;
    const fileSizeText =
      fileSizeKB > 1024
        ? `${(fileSizeKB / 1024).toFixed(2)} MB`
        : `${fileSizeKB.toFixed(2)} KB`;

    toast(`PDF generated (${fileSizeText})`, "SUCCESS");

    const fileName = selectedVendor
      ? `payment_Details${vendorName}.pdf`
      : "payment_Details.pdf";

    doc.save(fileName);
  };
  const generatePaymentDetailsPDF = (payment, trips = []) => {
    const doc = new jsPDF({ orientation: "landscape", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();

    const capitalize = (str) => {
      if (!str) return "N/A";
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    addPDFHeader(doc, pageWidth);

    const vendor = vendors.find((v) => v.id === payment.vendor_id);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Payment Receipt", pageWidth / 2, 45, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(`Date: ${formatDate(payment.date)}`, 20, 59);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(`Bill No: ${payment.id}`, 217, 59);

    const leftDetails = [
      { label: "Vendor Name", value: capitalize(vendor?.name) || "N/A" },
      { label: "Trip Count", value: payment.trip_count },
      {
        label: "Total Amount",
        value: payment.total_amount?.toFixed(2) || "0.00",
      },
    ];

    const rightDetails = [
      {
        label: "Normal Advance Deduction",
        value: payment.nor_advance_deduction?.toFixed(2) || "0.00",
      },
      {
        label: "Receipt Advance Deduction",
        value: payment.res_advance_deduction?.toFixed(2) || "0.00",
      },
      {
        label: "Paid Amount",
        value: payment.payable_amount?.toFixed(2) || "0.00",
      },
    ];

    let leftY = 72,
      rightY = 72;
    const leftX = 20,
      rightX = pageWidth / 2 + 20;

    doc.setFontSize(11);

    leftDetails.forEach((d) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${d.label}:`, leftX, leftY);
      doc.setFont("helvetica", "normal");
      doc.text(String(d.value || "N/A"), leftX + 45, leftY);
      leftY += 8;
    });

    rightDetails.forEach((d) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${d.label}:`, rightX, rightY);
      doc.setFont("helvetica", "normal");
      doc.text(String(d.value || "0.00"), rightX + 55, rightY);
      rightY += 8;
    });

    const startY = Math.max(leftY, rightY) + 5;

    const tableColumns = [
      "S.No",
      "Date",
      "Vehicle",
      "Source",
      "Destination",
      "Rate",
      "Total KM",
      "Total Tones",
      "Amount",
      "Weighment Charges",
      "Advance Amount",
      "Balance Amount",
    ];

    const tableRows = trips.map((trip, index) => {
      console.log("trip", trip);

      const selectedVehicle = vehicles.find((v) => v.id === trip.vehicle_id);

      return [
        index + 1,
        formatDate(trip.date),
        selectedVehicle?.vehicle_number || "N/A",
        capitalize(trip.source_name) || "N/A",
        capitalize(trip.destination_name) || "N/A",
        trip.rate?.toFixed(2) || "0.00",
        trip.total_km,
        trip.total_tones,
        trip.amount?.toFixed(2) || "0.00",
        trip.transition_charge?.toFixed(2) || "0.00",
        trip.advance_amount?.toFixed(2) || "0.00",
        trip.balance_amount?.toFixed(2) || "0.00",
      ];
    });

    autoTable(doc, {
      startY: startY,
      head: [tableColumns],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: "bold",
      },
    });

    doc.save(`payment_${vendor?.name || "Report"}.pdf`);
  };

  return (
    <Main>
      <PageContainer>
        <CollapseCard title="Filters">
          <PaymentFilter
            filters={filters}
            vendors={vendors}
            vehicles={vehicles}
            onFilterChange={handleFilterChange}
            onFind={handleFilter}
            onReset={handleReset}
            loading={loading}
          />
        </CollapseCard>

        <CollapseCard title="Payment Details">
          <Table size="sm">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Vendor</th>
                <th>Trip Count</th>
                <th>Total Amount</th>
                {/* <th>Normal Advance Deduction</th>
                <th>Receipt Advance Deduction</th> */}
                <th>Payable Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showResults &&
                (filteredPayments.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  filteredPayments.map((p, index) => {
                    const vendorName = vendors.find(
                      (v) => v.id === p.vendor_id,
                    );

                    return (
                      <tr key={p.id}>
                        <td>{index + 1}</td>
                        <td>{formatDate(p.date)}</td>
                        <td style={{ textTransform: "capitalize" }}>
                          {vendorName?.name || "N/A"}
                        </td>
                        <td>{p.trip_count}</td>
                        <td>{p.total_amount.toFixed(2)}</td>
                        {/* <td>{p.nor_advance_deduction}</td>
                        <td>{p.res_advance_deduction}</td> */}
                        <td>{p.payable_amount.toFixed(2)}</td>
                        <td>
                          <Button
                            variant="primary"
                            size="sm"
                            // onClick={() => generatePaymentDetailsPDF(p, p.trips || [])}

                            onClick={() => {
                              const billTrips = allTrips.filter(
                                (t) => t.bill_id === p.id,
                              );
                              generatePaymentDetailsPDF(p, billTrips);
                            }}
                          >
                            PDF
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                ))}
            </tbody>
          </Table>
        </CollapseCard>
        <div className="d-flex justify-content-end mb-2 mt-2">
          <Button variant="success" size="sm" onClick={generatePaymentTablePDF}>
            <Download /> Download PDF
          </Button>
        </div>
      </PageContainer>
    </Main>
  );
};

export default PaymentReportPage;
